module.exports = __webpack_public_path__ + "img/assistance_monassistance.a9844f15.svg";